/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDevicesRebootMutationResponse, StreamerBoxStreamerBoxDevicesRebootPathParams } from "../models/StreamerBoxStreamerBoxDevicesReboot";

export function getStreamerBoxStreamerBoxDevicesRebootUrl(uuidOrId: StreamerBoxStreamerBoxDevicesRebootPathParams["uuidOrId"]) {
  const res = { method: 'POST', url: `/streamer-box/devices/${uuidOrId}/reboot` as const }
  return res
}

/**
 * @description Reboots the Balena device.
 * @summary Reboot device
 * {@link /streamer-box/devices/:uuidOrId/reboot}
 */
export async function streamerBoxStreamerBoxDevicesReboot(uuidOrId: StreamerBoxStreamerBoxDevicesRebootPathParams["uuidOrId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDevicesRebootMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStreamerBoxStreamerBoxDevicesRebootUrl(uuidOrId).url.toString(), ... requestConfig })
  return res.data
}